export class ParticipantOffersInvolvingProcessDialogContentAdapter {
  public static adapt(htmlContent: string): string {
    const indexOfLastBrTag = htmlContent.lastIndexOf('<br/>') + 5;
    const firstBlock = htmlContent.substring(0, indexOfLastBrTag);
    const secondBlock =
      '<span class="modal-content-note">' + htmlContent.substring(indexOfLastBrTag) + '</span>';

    return firstBlock + secondBlock;
  }
}
